import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function AddmodifyRoiSlab() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [ID, setID] = useState(0);
  const [fromev, setfromev] = useState("");
  const [toev, settoev] = useState("");
  const [roiamount, setroiamount] = useState("");
  const [roimonths, setroimonths] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.get(
        `GetPlans?type=RoiSlab&loginid=${userId}`,
        {
          headers: {
            Authorization: `${jwt_token}`,
            "Content-Type": "application/json",
          },
        },
      );

      responceRight = responceRight?.data?.data[0];

      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          // id	fromev	toev	roiamount	roimonths
          sr: index + 1,
          id: item.id,
          fromev: item.fromev,
          toev: item.toev,
          roiamount: item.roiamount,
          roimonths: item.roimonths,
          update: (
            <>
              <input
                type="button"
                id="btnsearch"
                onClick={(e) => {
                  setfromev(item.fromev);
                  settoev(item.toev);
                  setroiamount(item.roiamount);
                  setroimonths(item.roimonths);
                  setID(item.id);
                }}
                class="btn btn-sm btn-primary"
                value="Modify Plan"
              />
            </>
          ),
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const AddnewPlan = async () => {
    setisLoading(true);
    try {
      if (
        fromev === "" ||
        fromev === 0 ||
        toev === "" ||
        toev === 0 ||
        roiamount === "" ||
        roiamount === 0 ||
        roimonths === "" ||
        roimonths === 0
      ) {
        toast.error("Enter All Required Fields");
        return;
      }

      let responceRight = await API?.post(
        "/InsertRoi_Slab_API",
        {
          loginid: userId,
          ID: ID,
          type: ID === 0 ? "Save" : "Update",
          fromev: fromev,
          toev: toev,
          roiamount: roiamount,
          roimonths: roimonths,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      console.log("My_Team", responceRight.data);
      if (
        responceRight.data.data.result === "Saved !!" ||
        responceRight.data.data.result === "Updated !!"
      ) {
        toast.success(responceRight.data.data.result);
        setID(0);
        setfromev("");
        settoev("");
        setroiamount("");
        setroimonths("");
        referral_API();
      } else {
        toast.error(responceRight.data.data.result);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "From EV", accessor: "fromev" },
      { Header: "To EV", accessor: "toev" },
      { Header: "Roi Amount", accessor: "roiamount" },
      { Header: "Roi Months", accessor: "roimonths" },
      { Header: "Modify", accessor: "update" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Add/Modify ROI Slab</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <label>From EV</label>
                      <input
                        type="number"
                        id="txtuid"
                        value={fromev}
                        onChange={(e) => setfromev(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="From EV"
                      />
                    </div>
                    <div class="col-md-2">
                      <label>To EV</label>
                      <input
                        type="number"
                        value={toev}
                        onChange={(e) => settoev(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="To EV"
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Roi Amount</label>
                      <input
                        type="number"
                        value={roiamount}
                        onChange={(e) => setroiamount(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Roi "
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Roi Months</label>
                      <input
                        type="number"
                        value={roimonths}
                        onChange={(e) => setroimonths(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Roi Months"
                      />
                    </div>

                    <div class="col-md-2">
                      <br />
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          AddnewPlan();
                        }}
                        class="btn btn-sm btn-primary"
                        value={
                          ID === 0 ? "Add New ROI Slab" : "Modify ROI Slab"
                        }
                      />
                    </div>
                  </div>
                  <div class="row">
                    {/* <h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4> */}

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddmodifyRoiSlab;
